<template>
    <div>
       <!-- 引流二维码 -->
		<van-dialog class="qr-dialog" v-model="qrShow"  :show-confirm-button="false">
			<div class="attractCode">
				<span>{{ liveinfo.tencent_title }}</span>
				<div class="qrcod">
					<img :src="liveinfo.tencent_qrcode" alt="" />
				</div>
				<span v-show="liveinfo.tencent_desc">{{ liveinfo.tencent_desc }}</span>
				<span v-show="liveinfo.tencent_mobile">服务热线：{{ liveinfo.tencent_mobile }}</span>
				<div class="delButton" @click="closeQicode"><van-icon name="cross" color="#fff" /></div>
			</div>
		</van-dialog>

        <!-- 输入邀请码 -->
		<van-dialog class="sign-dialog" v-model="inviteCodeShow"  :show-confirm-button="false" className="passoverlay" overlayClass="passoverlays" >
			<div class="attractCode">
				<div style="display: flex; flex-direction: column; align-items: center;">
                <span class="passtext" >直播间邀请码</span>
                <div class="borderline" ></div>
                </div>
				<van-icon class="question-o" @click="showNotice" name="question-o" color="#bbb"/>
				<van-form @submit="onSubmitInviteCode">
					<div class="formprefix">
						<div class="prefix">
							<img src="@/assets/images/yuechi.png" alt="" />
						</div>
						<van-field  :border="false"  v-model="inviteCode" name="邀请码" placeholder="请输入直播间邀请码" />
					</div>
					<div class="subbutton">
						<van-button class="subbuttonvan" native-type="submit"
							>提交</van-button
						>
					</div>
				</van-form>
			</div>
		</van-dialog>

		<!-- 直播签到 -->
		<van-dialog class="sign-dialog" v-model="signShow"  :show-confirm-button="false" className="signoverlay" overlayClass="signoverlays" >
			<div class="attractCode">
				<!-- <span>直播间签到</span> -->
				<div style="display: flex; flex-direction: column; align-items: center;">
                <span class="passtext" >实名签到</span>
                <div class="borderline" ></div>
                </div>

				<van-form @submit="onSubmitSign">
					<div class="formprefix">
						<van-field :border="false" v-model="signinfo.name" name="用户名" placeholder="请输入姓名"   />
					</div>
					<div class="formprefix">
						<van-field :border="false" v-model="signinfo.mobile" type="digit" maxlength="11" name="手机号" placeholder="请输入手机号"  />
					</div>
					<div class="formprefix">
						<van-field :border="false" v-model="signinfo.code" name="验证码" placeholder="请输入">
							<template #button>
								<span @click="getCode" v-show="codeTime >= 60" style="color: #1ea0d9">获取验证码</span>
								<span v-show="codeTime < 60" style="color: #1ea0d9">{{ codeTime }}s</span>
							</template>
						</van-field>
					</div>
					<!-- <div class="notice" style="font-size: 12px; color: #bbb; margin-top: 10px">提醒：完成实名签到才可参与抽奖</div> -->
					<div  class="signsubmit_box">
						<van-button native-type="submit" class="signsubmit" >立即签到</van-button>
					</div>
				</van-form>

				<div class="delButton" v-if="!liveinfo.is_real" style="" @click="closeSign"><van-icon name="cross" color="#bbb" /></div>
			</div>
		</van-dialog>

    </div>
</template>

<script>
import vueQr from 'vue-qr'
import * as api from "@/api/live";
import { checkMobile, checkName } from "@/utils/utils.js";

    export default {
        components:{
            vueQr
        },
        data(){
            return {
                inviteCode:'',
				signinfo: {
					name:'',
					mobile:'',
					code:''
				},
				codeTime: 60,
				timer:null,
				codefalg:false
            }
        },
        props:{
            qrShow:{
                type:Boolean,
                default:false
            },
			signShow:{
                type:Boolean,
                default:false
            },
            inviteCodeShow:{
                type:Boolean,
                default:false
            },
            liveinfo:{
                type:Object,
                default(){
                    return {}
                }
            },
			live_id:{
                type: [String, Number],
			    default: "",
            },
            userId:{
                type: [String, Number],
			    default: "",
            }
        
        },
        mounted(){
            
        },
        methods:{
            // 直播间邀请码提醒
            showNotice() {
                this.$toast({
                    message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">邀请码由直播主办方提供</div>',
                    type: "html",
                });
            },
            closeQicode(){
                this.$emit('update:qrShow',false)
            },
            onSubmitInviteCode(){
                this.$emit('fnSubmitInviteCode',this.inviteCode)
            },
			closeSign(){
				this.$emit('update:signShow',false)
			},
			//获取短信验证码
			getCode() {			
				
				if(this.codefalg){
					return false
				}
				if (this.timer) {
					clearInterval(this.timer);
				}
				console.log(9999)
				if (this.signinfo.mobile == "") {
					this.$toast({
						message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写手机号</div>',
						type: "html",
					});
					return;

				}
				if (this.signinfo.mobile != "" && !checkMobile(this.signinfo.mobile)) {
					this.$toast({
						message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写正确手机号</div>',
						type: "html",
					});
					return;
				}
				
				this.codefalg = true
				const data = { mobile: this.signinfo.mobile };
				api.getMobileCode(data).then((res) => {
					if (res.code === 200) {
						this.timer = setInterval(() => {
							this.codeTime--;
							if (this.codeTime <= 0) {
								clearInterval(this.timer);
								this.codeTime = 60;
								this.codefalg = false;
							}
						}, 1000);
						
					}else{
						this.codefalg = false;
					}
				});
			},
			onSubmitSign() {
				if (this.signinfo.name == "") {
					this.$toast({
						message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写姓名</div>',
						type: "html",
					});
					return;
				}
				if (this.signinfo.name != "" && !checkName(this.signinfo.name)) {
					this.$toast({
						message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写2-6位汉字姓名</div>',
						type: "html",
					});
					return;
				}
				if (this.signinfo.mobile == "") {
					this.$toast({
						message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写手机号</div>',
						type: "html",
					});
					return;
				}
				if (this.signinfo.mobile != "" && !checkMobile(this.signinfo.mobile)) {
					this.$toast({
						message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写正确手机号</div>',
						type: "html",
					});
					return;
				}
				if (this.signinfo.code == "") {
					this.$toast({
						message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写验证码</div>',
						type: "html",
					});
					return;
				}
				this.signinfo.live_id = this.live_id;
				this.signinfo.user_id = this.userId;
				api.liveSign(this.signinfo).then((res) => {
					if (res.code == 200) {
						this.$toast.success("签到成功");
						this.signinfo = {
							name:'',
							mobile:'',
							code:''
						};
						this.$emit('fnclosesign')
						clearInterval(this.timer);
						this.codeTime = 60;
					} else {
						this.$toast(res.message);
					}
				});
			},
        }
    }
</script>
<style lang="less" scoped>
@import "../assets/styles/dialogcommon.less";
.signsubmit{
	background-color: #1ea0d9;
	color: #fff; 
	height: 28px; 
	width: 100px;
	line-height: 28px;
}
.signsubmit_box{
	margin-top: 16px;
}
.qr-dialog {
	background: url("../assets/images/qrcode-bg.png");
	color: white;
	background-size: 100% 100%;
	width:253px;
	&.intab {
		height: 290px;
		width: 290px;
		display: flex;
		justify-content: center;
		margin-top: 40px;
	}
	.attractCode {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-sizing: border-box;
		padding-bottom: 20px;
		.qrcod {
			margin-top: 10px;
			width: 112px;
			height: 110px;
			border-radius: 20px;
			img {
				border-radius: 20px;
				width: 100%;
				height: 100%;
			}
		}
		.delButton {
			position: absolute;
			background-color: #1ea0d9;
			border: 1px solid #fff;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 20px;
			width: 20px;
			left: 88%;
			top: 5px;
		}
		span {
			&:first-child {
				margin-top: 20px;
			}
			&:last-child {
				margin-bottom: 20px;
			}
			margin-top: 10px;
		}
	}
}
.borderline{
	margin-top: 3px; 
	width: 70px;
	height: 2px; 
	background-color: #1ab4ec
}
.formprefix{
	display: flex;
	align-content: center;
	border: 1px solid #DCDFE6;
	border-radius: 4px;
	margin-top:15px;
	width: 230px;
}
.prefix{
	width: 35px;
	 height: 35px; 
	 display: flex; 
	 align-items: center;
	font-style: normal; 
	text-decoration: none; 
	opacity: 0.9;
	img{
		width: 33px; 
		height: 33px;
		
	}
}
.subbutton{
	margin-top: 16px;
	.subbuttonvan{
		background-color: #1ea0d9;
		color: #fff; 
		height: 30px; 
		width: 70px; 
		line-height: 35px
	}
}
.passtext{
	font-size: 18px; 
	font-weight: 550;
	color: #000;
	margin-top: 20px;
}
.question-o{
	font-size: 14px;
	position: absolute; 
	right: -10px;
	z-index: 90;
	top: 10px;
}

</style>
<style  lang="less">
.passoverlay{
	width:300px;
	z-index: 2004!important;
}
.passoverlays{
	z-index: 2003!important;
}
.signoverlay{
	width:300px;
	z-index: 2002!important;
}
.signoverlays{
	z-index: 2001!important;
}
.formprefix .van-field__value{
	border: none!important;
	margin-top: 0!important;
	height: 35px!important;
	line-height: 35px!important;
}


</style>
